import { logBreadcrumb } from 'shared/utils/sentry/sentry';

export const registerServiceWorker = (): void => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          logBreadcrumb({
            level: 'info',
            message: 'Service Worker registered',
            data: { scope: registration.scope },
          });
        })
        .catch((error) => {
          logBreadcrumb({
            level: 'error',
            message: 'Service Worker registration failed',
            data: {
              error: error instanceof Error ? error.message : String(error),
            },
          });
        });
    });
  }
};
